import { TruckIcon } from '@heroicons/react/20/solid';
import { useApp } from '@retainerclub/hooks';
import RcSelect from '../../../../shared/FormElements/Selects/RcSelect';

const shippingOptions = [
  { id: 'partner_location', name: 'Orthodontic office' },
  { id: 'patient_address', name: "Patient's home address" },
];

function WarrantyFormShippingOptions() {
  const { isPartner, isAdmin } = useApp();

  return isAdmin || isPartner ? (
    <div className="rounded-md bg-green-50 p-4 text-left dark:bg-green-500/10 dark:outline dark:outline-green-500/20">
      <div className="flex">
        <div className="shrink-0">
          <TruckIcon aria-hidden="true" className="size-5 text-green-400" />
        </div>
        <div className="ml-3 flex-1">
          <h3 className="font-medium text-green-800 text-sm dark:text-green-200">
            Shipping Preference
          </h3>
          <div className="mt-2">
            <RcSelect
              name="whereToShip"
              data={shippingOptions}
              clearable={false}
            />
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

export default WarrantyFormShippingOptions;
